import { render, staticRenderFns } from "./address-comp.vue?vue&type=template&id=5fae1eba&scoped=true"
import script from "./address-comp.vue?vue&type=script&lang=js"
export * from "./address-comp.vue?vue&type=script&lang=js"
import style0 from "./address-comp.vue?vue&type=style&index=0&id=5fae1eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae1eba",
  null
  
)

export default component.exports